import React from 'react';

const QuizLoadingSkeleton = () => {
  return (
    <div className="p-6 animate-pulse">
      {/* Question title skeleton */}
      <div className="mb-8">
        <div className="h-6 bg-gray-200 rounded w-3/4 mb-2"></div>
        <div className="h-6 bg-gray-200 rounded w-1/2"></div>
      </div>

      {/* Answer options skeleton - matching the simple radio button style */}
      <div className="space-y-4">
        {[...Array(5)].map((_, index) => (
          <div 
            key={index}
            className="border border-gray-200 rounded-lg p-4"
          >
            <div className="flex items-center">
              <div className="w-5 h-5 mr-3 rounded-full border border-gray-300 bg-white"></div>
              <div className="flex-grow">
                <div className="h-5 bg-gray-200 rounded w-1/2"></div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default QuizLoadingSkeleton;